
export default {
    name: 'edit-taux-assurance',
    components: {},
    props: ["taux_couverture", "taux_toggler"],
    data() {
        return {
            save_loading: false,
            taux_assurance: '',
            warning_message: "",
        }
    },

    watch: {
        taux_assurance() {
            this.warning_message = ""
        },

        taux_toggler() {
            this.taux_assurance = this.taux_couverture
        }
    },

    computed: {

    },
    
    mounted() {
        
    },

    methods: {
        async save() {
            const is_empty = this.validateStringNotEmpty(this.taux_assurance)

            if (is_empty) {
                this.warning_message = "Vous devez saisir un nombre !"
                return;
            }

            this.taux_assurance = this.cleanNumber(this.taux_assurance)
            

            if (this.taux_assurance > 100) {
                this.warning_message = "Le taux saisi a dépassé la limite !"
                return
            }

            

            this.save_loading = true

            this.$emit('emitTauxCouverture', this.taux_assurance)

            this.save_loading = false
            this.taux_assurance = ''
            this.$refs.edit_taux_assur.click()
        }
    }
}